import React from "react";

import { Main } from "./Mian";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";
import { Footer } from "./Footer";
import { DrawerProvider } from "../context/Drawer";

/**
 * PageLayout component for wrapping pages.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @param {Function} [props.onLogout]
 * @param {React.CSSProperties} [props.style]
 */
export function PageLayout({ children, onLogout = undefined, style = undefined }) {
  return (
    <DrawerProvider>
      <Header />
      <Sidebar onLogout={onLogout} />
      <Main style={{ ...mainStyle, ...style }}>
        <div style={{ flex: 1 }}>{children}</div>
        <Footer />
      </Main>
    </DrawerProvider>
  );
}

const mainStyle = {
  display: "flex",
  flexDirection: "column",
  minHeight: `calc(100vh - 75px)`,
};
